import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutOverlay',
  emits: ['closeOverlay'],
  setup(__props, { emit: __emit }) {

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = __emit

function closeOverlay() {
  emit('closeOverlay')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "layout-overlay",
    onMousedown: _withModifiers(closeOverlay, ["self"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 32))
}
}

})